var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25.3201V22.6801C9 21.1201 10.275 19.8301 11.85 19.8301C14.565 19.8301 15.675 17.9101 14.31 15.5551C13.53 14.2051 13.995 12.4501 15.36 11.6701L17.955 10.1851C19.14 9.48015 20.67 9.90015 21.375 11.0851L21.54 11.3701C22.89 13.7251 25.11 13.7251 26.475 11.3701L26.64 11.0851C27.345 9.90015 28.875 9.48015 30.06 10.1851L32.655 11.6701C34.02 12.4501 34.485 14.2051 33.705 15.5551C32.34 17.9101 33.45 19.8301 36.165 19.8301C37.725 19.8301 39.015 21.1051 39.015 22.6801V25.3201C39.015 26.8801 37.74 28.1701 36.165 28.1701C33.45 28.1701 32.34 30.0901 33.705 32.4451C34.485 33.8101 34.02 35.5501 32.655 36.3301L30.06 37.8151C28.875 38.5201 27.345 38.1002 26.64 36.9151L26.475 36.6301C25.125 34.2752 22.905 34.2752 21.54 36.6301L21.375 36.9151C20.67 38.1002 19.14 38.5201 17.955 37.8151L15.36 36.3301C13.995 35.5501 13.53 33.7951 14.31 32.4451C15.675 30.0901 14.565 28.1701 11.85 28.1701C10.275 28.1701 9 26.8801 9 25.3201Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.875C26.6924 28.875 28.875 26.6924 28.875 24C28.875 21.3076 26.6924 19.125 24 19.125C21.3076 19.125 19.125 21.3076 19.125 24C19.125 26.6924 21.3076 28.875 24 28.875Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.b3bf44e1881d82633d171c2b2da6bc14.svg";
export { ForwardRef as ReactComponent };